import { Component, OnInit } from '@angular/core';
import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { AuthService } from '../../../auth.service';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent implements OnInit {
  constructor(private classToggler: ClassToggleService, private auth: AuthService) {
    super();
  }

  public login: string;

  ngOnInit(): void {
    /*this.auth.getWhoAmI().subscribe(data => {
      this.login = data.login;
    });*/
  }

  toggleTheme() {
    this.classToggler.toggle('.c-app', 'c-dark-theme');
  }
}
